export default __webpack_public_path__ + "static/media/2018_Smith_et_al_2018_NatureEcolEvol.39b823d5.pdf";